import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { fieldsMapPaths } from "@Client/@Composables/application-standalone/validations/requiredValidationField";
import { computed, ref } from "@vue/composition-api";
import { useVuelidate } from "@vuelidate/core";
import { helpers, maxValue, required } from "@vuelidate/validators";
import { futureDate, withValidDate } from "@Shared/@Utils/validation-rules";
import { minValueNotRequired } from "@Shared/@Utils/new-validation-rules";
import { goalsBindingsAndVisibilities } from "../pages/goals/goalsBindingsAndVisibilities";
import { getValidationRulesFromMap } from "@Client/@Composables/application-standalone/validations/getValidationRulesFromMap";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { APPLICATION_FLOW } from "@Shared/@Types/application/application-enums";
export const goalsPageValidator = ({
  lazy = false,
  scope = true
} = {}) => {
  const {
    bindings
  } = goalsBindingsAndVisibilities(ref(0));
  const {
    propertyDetailsPurchasePrice,
    propertyAddress,
    propertyDetailsAddressProvince,
    mortgageDetailsDownpaymentAmount,
    mortgageDetailsClosingDate
  } = bindings;
  const {
    GET_SCHEMA_RULES_BY_PATH,
    MORTGAGE_DETAILS_REQUESTED,
    PROPERTY_REQUESTED,
    HAS_CONSOLIDATED_REQUEST
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.MORTGAGE_DETAILS_REQUESTED, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST, ApplicationStandaloneGetters.PROPERTY_REQUESTED]);
  const areRulesVisibleFromFillOut = path => {
    const isMortgageDetails = _includesInstanceProperty(path).call(path, "mortgage-details");
    const isProperty = _includesInstanceProperty(path).call(path, "property");
    return !HAS_CONSOLIDATED_REQUEST.value || MORTGAGE_DETAILS_REQUESTED.value && isMortgageDetails || PROPERTY_REQUESTED.value && isProperty;
  };
  const rules = computed(() => {
    return getValidationRulesFromMap(areRulesVisibleFromFillOut, GET_SCHEMA_RULES_BY_PATH, goalsPageRules);
  });
  const v$ = useVuelidate(rules, {
    mortgageDetailsClosingDate,
    propertyDetailsPurchasePrice,
    propertyAddress,
    mortgageDetailsDownpaymentAmount,
    propertyDetailsAddressProvince
  }, {
    $scope: scope,
    $lazy: lazy
  });
  return {
    v$
  };
};
export const AddressRules = {
  line1: {
    required
  },
  "street-number": {
    required
  },
  "street-name": {
    required
  },
  city: {
    required
  },
  province: {
    required
  },
  "postal-code": {
    required
  }
};
export const AddressRulesWithoutPreaproval = {
  line1: ({
    getCurrentFlow
  }) => getCurrentFlow() != APPLICATION_FLOW.PRE_APPROVAL ? {
    required
  } : {},
  "street-number": ({
    getCurrentFlow
  }) => getCurrentFlow() != APPLICATION_FLOW.PRE_APPROVAL ? {
    required
  } : {},
  "street-name": ({
    getCurrentFlow
  }) => getCurrentFlow() != APPLICATION_FLOW.PRE_APPROVAL ? {
    required
  } : {},
  city: ({
    getCurrentFlow
  }) => getCurrentFlow() != APPLICATION_FLOW.PRE_APPROVAL ? {
    required
  } : {},
  province: ({
    getCurrentFlow
  }) => getCurrentFlow() != APPLICATION_FLOW.PRE_APPROVAL ? {
    required
  } : {},
  "postal-code": ({
    getCurrentFlow
  }) => getCurrentFlow() != APPLICATION_FLOW.PRE_APPROVAL ? {
    required
  } : {}
};
const goalsPageRules = {
  mortgageDetailsClosingDate: {
    withValidDate: () => withValidDate,
    futureDate: () => futureDate
  },
  propertyDetailsPurchasePrice: {
    validPurchasePrice: ({
      isRequired
    }) => minValueNotRequired(1000, isRequired),
    maxValue: maxValue(1000000000000)
  },
  propertyDetailsAddressProvince: {},
  propertyAddress: AddressRulesWithoutPreaproval,
  mortgageDetailsDownpaymentAmount: {
    maxValue: ({
      getVisibilityByPath
    }) => {
      if (getVisibilityByPath(fieldsMapPaths.propertyDetailsPurchasePrice)) {
        return helpers.withParams({
          max: "the same as purchase price"
        }, (value, siblings) => {
          return +value <= siblings.propertyDetailsPurchasePrice.value;
        });
      } else return {};
    }
  }
};